export const HEYGEN_KV_CACHE_KEYS = {
    publicAvatars: "heygen:public-avatars:v1",
    publicVoices: (lang?: string, gender?: string) =>
        `heygen:public-voices:v1:${lang ?? "all"}:${gender ?? "all"}`,
} as const;

export const HEYGEN_KV_TTL_SECONDS = 60 * 60 * 24; // 24h

export const DEFAULT_AVATAR_CORNER_SIZE = 240;
